import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 213,
	height: 203,
	viewBox: "0 0 213 203",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M50.0327 101.447C35.4443 112.346 40.0866 121.577 33.3174 129.796C28.5851 135.543 8.1408 135.081 1.61367 149.275C-4.91372 163.469 8.96973 175.073 32.2812 179.114C55.5929 183.154 71.7558 186.159 84.0849 195.898C96.4143 205.637 128.015 206.362 148.322 189.474C168.629 172.586 201.161 187.057 211.522 164.263C219.211 147.348 193.495 140.157 191.422 127.31C189.35 114.463 171.103 93.4304 144.586 102.444C118.068 111.458 72.3084 84.8063 50.0327 101.447Z",
			fill: "#F1F1F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.144 138.021C149.808 135.606 144.892 131.201 146.94 128.146C146.939 128.146 146.939 128.146 146.938 128.147C150.774 122.233 152.973 115.156 152.973 107.212C152.973 83.2575 132.992 63.8379 108.344 63.8379C83.6958 63.8379 63.7146 83.2575 63.7146 107.212C63.7146 112.081 64.5398 116.624 66.0618 120.773C67.4371 124.488 63.8302 131.228 64.4971 135.229C64.9272 139.034 62.2267 139.656 63.3357 143.184C64.4602 147.023 64.8686 148.242 73.3501 150.666C76.7531 151.822 81.6814 150.693 89.0579 154.149C93.1489 156.418 99.0674 162.115 110.715 158.674C127.202 154.076 123.765 155.86 131.896 155.631C140.237 156.503 147.941 153.853 150.727 148.938C154.262 142.337 152.48 140.437 151.144 138.021Z",
			fill: "#FF96C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.5509 156.148C59.6256 156.022 59.9165 156.325 59.3868 156.634C59.4191 156.744 59.4706 156.693 59.4097 156.69C59.5224 156.486 59.9499 155.697 59.7529 156.083C59.6256 156.074 59.5741 156.125 59.5509 156.148Z",
			fill: "#FF96C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.6134 130.82C64.0104 133.162 62.7838 137.178 60.1309 142.065C57.1551 147.547 62.1395 151.47 69.3424 151.731C73.8012 152.353 74.5773 149.18 79.2762 155.708C82.824 160.637 89.7611 160.646 100.151 158.576C105.603 157.809 103.949 159.319 101.046 157.169C92.5689 153.889 93.0674 150.888 84.7561 147.84C75.9299 144.607 74.9301 146.8 69.4663 142.991C62.7553 138.297 66.1341 129.706 65.6134 130.82Z",
			fill: "#F17C90"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.143 138.022C149.807 135.607 144.891 131.202 146.939 128.147C146.938 128.147 146.937 128.147 146.937 128.147C150.773 122.234 152.972 115.157 152.972 107.213C152.972 97.7835 143.207 95.0167 140.878 101.312C139.962 103.822 145.175 110.391 144.247 113.691C141.5 126.272 147.367 137.216 151.143 138.022Z",
			fill: "#F17C90"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.4243 81.859C92.5962 84.4183 90.8637 89.4572 86.5548 93.1136C82.2463 96.7698 76.9929 97.6594 74.8209 95.1004C72.6493 92.5411 74.3815 87.5022 78.6904 83.846C82.9989 80.1896 88.2523 79.3 90.4243 81.859Z",
			fill: "#FFB8D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.8671 110.242C94.8671 112.792 92.8003 114.859 90.2507 114.859C87.7013 114.859 85.6343 112.792 85.6343 110.242C85.6343 107.693 87.7013 105.626 90.2507 105.626C92.8003 105.626 94.8671 107.693 94.8671 110.242Z",
			fill: "#413E4B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.487 113.706C123.487 113.706 125.295 113.952 124.56 115.182C124.356 115.562 124.035 116.557 124.894 117.005C125.673 117.489 126.887 117.555 127.42 116.599C128.639 115.071 126.81 115.607 128.075 113.983C127.239 112.773 123.487 113.706 123.487 113.706Z",
			fill: "#FFB8D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.583 110.242C130.583 112.792 128.517 114.859 125.967 114.859C123.418 114.859 121.351 112.792 121.351 110.242C121.351 107.693 123.418 105.626 125.967 105.626C128.517 105.626 130.583 107.693 130.583 110.242Z",
			fill: "#413E4B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.606 119.875C102.606 119.875 103.828 118.776 108.248 118.776C112.669 118.776 113.612 119.875 113.612 119.875",
			stroke: "#413E4B",
			strokeWidth: 11.75,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M132.407 177.815C129.975 178.055 129.299 180.664 131.114 181.668C133.046 182.61 138.06 181.95 138.001 180.255C137.973 178.564 135.735 177.451 132.407 177.815Z",
			fill: "#FF96C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.618 68.9774L153.052 96.2852L149.208 7.79015C148.941 1.64015 141.361 -1.10335 137.219 3.45029L77.618 68.9774Z",
			fill: "#FDA691"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.728 106.302L73.7574 78.7997C71.8507 78.1093 70.8642 76.0036 71.5545 74.0964L72.6453 71.0832C73.3357 69.1762 75.4413 68.1899 77.3486 68.8803L153.319 96.3825C155.226 97.0728 156.213 99.1785 155.522 101.086L154.431 104.099C153.741 106.006 151.635 106.992 149.728 106.302Z",
			fill: "#FDC271"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.7574 78.7997C71.8507 78.1093 70.8642 76.0036 71.5545 74.0964L72.6453 71.0832C73.3357 69.1762 75.4413 68.1899 77.3486 68.8803C77.3486 68.8803 93.6663 74.8725 105.684 79.1416C105.72 79.081 95.2214 86.558 95.268 86.5664C82.8053 82.1035 73.7574 78.7997 73.7574 78.7997Z",
			fill: "#FFF8D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M150.297 32.7506C150.297 32.7506 147.255 67.6937 113.807 82.0725C129.645 87.8057 153.056 96.2809 153.056 96.2809L150.297 32.7506Z",
			fill: "#FE917A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.293 47.3945L125.265 63.314",
			stroke: "#FB764D",
			strokeWidth: 16.9723,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.586 34.272L129.558 50.1915",
			stroke: "#FB764D",
			strokeWidth: 16.9723,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.975 58.7119L106.888 66.525",
			stroke: "#FB764D",
			strokeWidth: 16.9723,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.747 73.9759L144.56 70.0636",
			stroke: "#F75D39",
			strokeWidth: 16.9723,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.113 46.4424L132.419 37.3479",
			stroke: "#FB764D",
			strokeWidth: 16.9723,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export { SvgError as ReactComponent };
